import classNames from 'classnames';

export interface ModalFooterProps {
  className?: string;
}

export function ModalFooter({ children, className }: React.PropsWithChildren<ModalFooterProps>) {
  return <div className={classNames('p-4 flex items-center justify-end space-x-2', className)}>{children}</div>;
}

export default ModalFooter;
